export default "__VITE_ASSET__87d08c0d__"